import { ethers } from "ethers";
import { getPublicClient } from "@wagmi/core";
import { config } from "../config/appkit";
import type { PublicClient } from "viem";

/**
 * Convert Viem PublicClient to Ethers Provider
 */
export function publicClientToProvider(publicClient: PublicClient) {
  const { chain, transport } = publicClient;
  
  if (!chain) {
    throw new Error("Chain is not available in PublicClient");
  }
  
  const network = {
    chainId: chain.id,
    name: chain.name,
    ensAddress: chain.contracts?.ensRegistry?.address,
  };

  if (transport.type === 'fallback') {
    const providers = (transport.transports as any[]).map((t) => 
      new ethers.JsonRpcProvider(t.value.url, network)
    );
    if (providers.length === 1) return providers[0];
    return new ethers.FallbackProvider(providers);
  }
  
  return new ethers.JsonRpcProvider(transport.url, network);
}

/**
 * Get ethers provider from wagmi config
 */
export function getEthersProvider(): ethers.Provider {
  const publicClient = getPublicClient(config);
  if (!publicClient) {
    throw new Error("Failed to get public client");
  }
  return publicClientToProvider(publicClient);
}